import Navbar from "../../component/Navbar";
import Footer from "../../component/Footer";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { baseurl } from "../../component/Baseurl";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import toastr from 'toastr';
import 'toastr/build/toastr.min.css'; // Import toastr styles

function DistributorLogin() {
  const [bgClass, setBgClass] = useState("");
  const [identifier, setIdentifier] = useState(""); // Single input for email or phone
  const [password, setPassword] = useState(""); // Password state
  const [error, setError] = useState(""); // To store any errors from login attempt
  const navigate = useNavigate();

  const bgClasses = ["bgban2", "bgban3", "bgban4", "bgban5"];

  // Select a random background class on component mount
  useEffect(() => {
    const randomIndex = Math.floor(Math.random() * bgClasses.length);
    setBgClass(bgClasses[randomIndex]);
  }, []);

  // Validate if the input is an email or phone number
  const isEmail = (input) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input);
  const isPhone = (input) => /^[0-9]{10}$/.test(input);

  // Handle form submission
  const handleLogin = async (e) => {
    e.preventDefault(); // Prevent default form submission
  
    try {
      // Validate input
      if (!identifier) {
        setError("Please provide an email or phone number.");
        return;
      }
  
      const isEmailInput = isEmail(identifier);
      const isPhoneInput = isPhone(identifier);
  
      if (!isEmailInput && !isPhoneInput) {
        setError("Invalid email or phone number format.");
        return;
      }
  
      // Prepare the request payload for distributor
      const payload = {
        email: isEmailInput ? identifier : null, // Send email if it's an email
        phone: isPhoneInput ? identifier : null, // Send phone if it's a phone
        password,
      };
  
      console.log("Login payload:", payload);
  
      // Send login data to the distributor login API
      const response = await axios.post(`${baseurl}Distributorlogin`, payload); // Adjusted API endpoint
  
      // Log the response to console
      console.log("Login response:", response);
  
      // Handle success
      if (response.status === 200) {
        const { id, email: distributorEmail, distributor_unique_id } = response.data.distributor;
  
        // Store distributor id, email, and unique id in localStorage
        localStorage.setItem("distributor_id", id);
        localStorage.setItem("distributor_email", distributorEmail);
        localStorage.setItem("distributor_unique_id", distributor_unique_id);
  
        console.log("Login successful", response.data);
  
        // Navigate to the distributor dashboard
        navigate("/distributor-dashboard");
      }
    } catch (error) {
      console.error("Login error:", error);
  
      if (error.response && error.response.status === 401) {
        toastr.error("Invalid email/phone or password", "Login Failed");
      } else {
        setError("Invalid email/phone or password");
      }
    }
  };
  
  

  return (
    <>
      <Navbar />
      <div className={`container-fluid login-container d-flex justify-content-center align-items-center ${bgClass}`}>
        <div className="login-card shadow form-container">
          <h3 className="text-center mb-4">State Head Login</h3>
          <form onSubmit={handleLogin}>
            {/* Email/Phone Input */}
            <div>
              <label htmlFor="identifier" className="form-label">Email or Phone</label>
              <input
                type="text"
                className="form-control input-field"
                id="identifier"
                placeholder="Enter your email or phone number"
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value)} // Bind input to state
              />
            </div>

            {/* Password Input */}
            <div>
              <label htmlFor="password" className="form-label">Password</label>
              <input
                type="password"
                className="form-control input-field"
                id="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)} // Bind password to state
                required
              />
            </div>

            {/* Forgot Password Link */}
            <div className="text-end">
              <Link to="/forget-password" className="forgot-link">Forgot Password?</Link>
            </div>

            {/* Error Message */}
            {error && <div className="alert alert-danger mt-2">{error}</div>}

            {/* Submit Button */}
            <button type="submit" className="btn btn-primary w-100 login-btn">
              Login
            </button>
          </form>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default DistributorLogin;
